/* Snackspot v2 — homepage script. Ported from the inline <script> of design/index v2.html
   (2026-09-05): the sugar bars, the ongkir calculator. Removed: the prototype's quick-add and
   the 3-bag click handler — both are <form data-ss-add> now, wired by ss-v2.js (the only cart
   AJAX; toast text comes from data-ss-toast). Added: the calculator's note copy and the
   "(max)" wording come from the section (data attributes), and the promo form's server reply
   is repeated as a toast. */
(function () {
  'use strict';
  var root = document.documentElement;
  var designMode = root.classList.contains('shopify-design-mode');

  // ---------- sugar bars animate in view ----------
  function initSugarBars() {
    var bars = document.querySelectorAll('.sugar2-bars:not([data-ss-ready])');
    if (!bars.length) return;
    function fill(el) { el.querySelectorAll('.fill').forEach(function (f) { f.style.width = (f.dataset.target || 0) + '%'; }); }
    bars.forEach(function (el) { el.setAttribute('data-ss-ready', ''); });
    // PORT: the theme editor and no-IntersectionObserver browsers see the bars filled at once.
    if (designMode || !('IntersectionObserver' in window)) { bars.forEach(fill); return; }
    var sugarObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        fill(e.target);
        sugarObs.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    bars.forEach(function (el) { sugarObs.observe(el); });
  }

  // ---------- Dynamic ongkir discount: up to Rp 10rb off per full Rp 100rb in cart ----------
  // Presentational (02-COMPONENTS §6). The real number is checkout's: min(earned, ongkir).
  function initCalc() {
    document.querySelectorAll('[data-calc]:not([data-ss-ready])').forEach(function (calc) {
      calc.setAttribute('data-ss-ready', '');
      var range = calc.querySelector('[data-calc-range]');
      if (!range) return;
      var cartEl = calc.querySelector('[data-calc-cart]');
      var discEl = calc.querySelector('[data-calc-disc]');
      var noteEl = calc.querySelector('[data-calc-note]');
      var step = parseInt(calc.dataset.step, 10) || 100000;
      var off = parseInt(calc.dataset.off, 10) || 10000;
      var noteFirst = calc.dataset.noteFirst || 'Add {toNext} to unlock up to Rp 10.000 off ongkir.';
      var noteNext = calc.dataset.noteNext || 'Add {toNext} more for up to another Rp 10.000 off.';
      var idr = window.ssRupiah || function (n) { return 'Rp ' + n.toLocaleString('id-ID'); };
      function update() {
        var v = +range.value;
        var disc = Math.floor(v / step) * off;
        var toNext = step - (v % step);
        if (cartEl) cartEl.textContent = idr(v);
        if (discEl) discEl.textContent = idr(disc);
        if (noteEl) noteEl.textContent = (disc === 0 ? noteFirst : noteNext).replace('{toNext}', idr(toNext));
      }
      range.addEventListener('input', update);
      update();
    });
  }

  // ---------- promo form: the server's reply, repeated as the toast the prototype showed ----------
  function initPromoStatus() {
    var s = document.querySelector('[data-ss-promo-status]:not([data-ss-ready])');
    if (!s) return;
    s.setAttribute('data-ss-ready', '');
    if (window.ssToast && s.textContent.trim()) window.ssToast(s.textContent.trim());
  }

  function init() { initSugarBars(); initCalc(); initPromoStatus(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
